"use client";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Children, type ReactNode } from "react";

interface CreditsCarouselProps {
  children: ReactNode;
}

const CreditsCarousel = ({ children }: CreditsCarouselProps) => {
  const items = Children.toArray(children);

  return (
    <Carousel
      opts={{
        align: "start",
      }}
      className="w-full max-w-5xl pb-10"
    >
      <CarouselContent className="-ml-4">
        {items.map((child, i) => (
          <CarouselItem
            key={i}
            className="flex basis-full items-stretch py-2 pl-4 transition-transform duration-300 ease-in-out sm:basis-1/2 lg:basis-1/3"
          >
            {child}
          </CarouselItem>
        ))}
      </CarouselContent>
      <div className="absolute bottom-1 left-1/2 -translate-x-1/2">
        <CarouselPrevious />
        <CarouselNext />
      </div>
    </Carousel>
  );
};

export default CreditsCarousel;
